/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface ExperienceProfessionnelleSearchDto
 */
export interface ExperienceProfessionnelleSearchDto {
    /**
     * 
     * @type {number}
     * @memberof ExperienceProfessionnelleSearchDto
     */
    idpersonne?: number;
    /**
     * 
     * @type {TextSearch}
     * @memberof ExperienceProfessionnelleSearchDto
     */
    fonction?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExperienceProfessionnelleSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ExperienceProfessionnelleSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ExperienceProfessionnelleSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExperienceProfessionnelleSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ExperienceProfessionnelleSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ExperienceProfessionnelleSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ExperienceProfessionnelleSearchDto interface.
 */
export function instanceOfExperienceProfessionnelleSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExperienceProfessionnelleSearchDtoFromJSON(json: any): ExperienceProfessionnelleSearchDto {
    return ExperienceProfessionnelleSearchDtoFromJSONTyped(json, false);
}

export function ExperienceProfessionnelleSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperienceProfessionnelleSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'fonction': !exists(json, 'fonction') ? undefined : TextSearchFromJSON(json['fonction']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ExperienceProfessionnelleSearchDtoToJSON(value?: ExperienceProfessionnelleSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idpersonne': value.idpersonne,
        'fonction': TextSearchToJSON(value.fonction),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

